import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { className: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { className: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { className: "fw-bolder text-dark" }, "Team And Funding"),
  /*#__PURE__*/_createElementVNode("div", { className: "text-gray-400 fw-bold fs-6" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check out "),
    /*#__PURE__*/_createElementVNode("a", { className: "link-primary fw-bolder" }, "Help Page"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_3 = { className: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { className: "form-label required" }, "Full-Time Founders", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: 1 }, "One", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: 2 }, "Two", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: 3 }, "Three", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: 4 }, "Four", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: 5 }, "Five", -1)
const _hoisted_10 = { className: "fv-row mb-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { className: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { className: "required" }, "Team Location")
], -1)
const _hoisted_12 = { className: "fv-row mb-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { className: "form-label" }, "Have you received investor funding? If so, how much?", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "10,000<" }, "€10,000", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "20,000" }, "€20,000", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "30,000" }, "€30,000", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "40,000" }, "€40,000", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "50,000" }, "€50,000", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "Other" }, "Other", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Field, {
        name: "fullTimeFounders",
        class: "form-select form-select-lg form-select-solid",
        "data-control": "select2",
        "data-placeholder": "Select...",
        "data-allow-clear": "true",
        "data-hide-search": "true",
        as: "select"
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9
        ]),
        _: 1
      }),
      _createVNode(_component_ErrorMessage, {
        name: "fullTimeFounders",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createVNode(_component_Field, {
        name: "teamLocation",
        class: "form-control form-control-lg form-control-solid"
      }),
      _createVNode(_component_ErrorMessage, {
        name: "teamLocation",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode(_component_Field, {
        name: "investorFunding",
        class: "form-select form-select-lg form-select-solid",
        "data-control": "select2",
        "data-placeholder": "Select...",
        "data-allow-clear": "true",
        "data-hide-search": "true",
        as: "select"
      }, {
        default: _withCtx(() => [
          _hoisted_14,
          _hoisted_15,
          _hoisted_16,
          _hoisted_17,
          _hoisted_18,
          _hoisted_19
        ]),
        _: 1
      }),
      _createVNode(_component_ErrorMessage, {
        name: "investorFunding",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ])
  ]))
}